export const RELEASE_FEATURES = {
    mainPageSearch: false,
    aiVet: false,
    additionalQuestions: false,
}
